import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { BrowserRouter } from "react-router-dom";
import App from "@/App";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Static SEO tags (for crawlers without JS) are replaced by Helmet once the app boots.
document.querySelectorAll("[data-static-seo]").forEach((n) => n.remove());
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
